import { flatten } from '~/utils/permissions'
import { permissions } from './permissions'
import { Role } from '~/types/users'

const { nav, subscription, partner, billing, customer, voucher } = permissions

const baseRoutePermissions: string[] = [
  ...flatten(nav.subscription),
  ...flatten(nav.customer),
  nav.changelog.list,
]

const subscriptionNotePermissions: string[] = [
  subscription.notes.add,
  subscription.notes.edit,
]

const baseActionPermissions: string[] = [
  ...subscriptionNotePermissions,
  partner.edit.details,
  partner.billing.edit,
  partner.team_members.add,
  partner.team_members.edit,
  partner.team_members.delete,
  subscription.edit,
  subscription.cancel,
  subscription.upgrade_printer_seats,
  subscription.change,
  billing.edit_po_number,
  subscription.access.send_invite,
  subscription.edit_po_number,
  subscription.extend_trial,
]

const baseSettingsPermissions: string[] = [
  nav.settings.information,
  nav.settings.billing,
  nav.settings.team_members,
  nav.settings.dealer_demo,
]

const basePermissions: string[] = [
  ...baseRoutePermissions,
  ...baseActionPermissions,
]

export const userPermissions: Partial<Record<Role, string[]>> = {
  [Role.ACCOUNT_ADMIN]: [
    ...baseRoutePermissions,
    ...flatten(nav.partner),
    ...subscriptionNotePermissions,
    subscription.extend_trial,
    partner.dealer_demo.invite,
    partner.view.status,
    partner.view.server_location,
    subscription.access.send_invite,
  ],
  [Role.ADMIN]: [
    ...basePermissions,
    ...flatten(nav.partner),
    customer.edit,
    partner.team_members.impersonate,
    partner.add,
    partner.delete,
    subscription.access.edit_instance,
    subscription.edit_subscription_name,
    partner.view.server_location,
    partner.view.status,
    subscription.view.opportunity_id,
    partner.dealer_demo.create,
    partner.dealer_demo.invite,
    subscription.apply_coupon,
    partner.edit.contract,
    partner.edit.tier,
    partner.edit.term,
  ],
  [Role.DISTRIBUTOR]: [
    ...basePermissions,
    ...baseSettingsPermissions,
    ...flatten(nav.reseller),
    nav.billing.list,
    nav.voucher.list,
    subscription.create,
    subscription.instance_name,
  ],
  [Role.RESELLER]: [
    ...basePermissions,
    ...baseSettingsPermissions,
    nav.billing.list,
    nav.voucher.claim,
    voucher.claim,
    subscription.create,
  ],
  [Role.PARTNER]: [
    ...basePermissions,
    ...baseSettingsPermissions,
    nav.billing.list,
    subscription.create,
  ],
}

export const systemAdminPermissions = [
  permissions.activity_log.view,
  partner.merge,
  subscription.max_printers,
  subscription.cancel_options,
  subscription.change_active,
  subscription.extend_trial,
  subscription.override_printer_seats,
  nav.events.list,
  nav.monitoring.list,
  nav.settings.user_management,
  nav.settings.notification_banner,
  partner.edit.all,
  subscription.salesforce_sync,
]
